import React from 'react';

function Chip({ label, active, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-2xl px-4 py-2 text-sm font-semibold transition ${
        active ? 'bg-navy text-white' : 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-50'
      }`}
    >
      {label}
    </button>
  );
}

function FilterChips({ filters, active, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {filters.map((f) => (
        <Chip key={f.value} label={f.label} active={active === f.value} onClick={() => onChange(f.value)} />
      ))}
    </div>
  );
}

export default FilterChips;

